import { sanityClient } from '@/content/sanity/sanity-client/sanity-client';

interface Event {
  date: string;
  time: string;
}

interface Location {
  locationName: string;
  address: string;
  events: Event[];
}

interface Section {
  title: string;
  description: string;
  image?: {
    asset: {
      _ref: string;
    };
  };
}

interface PrinceGeorgePageContent {
  headerTitle: string;
  locations: Location[];
  aboutSection: Section;
  groundSection: Section;
  findUsSection: Section;
  hiringSection: {
    title: string;
    description: string;
    contactEmail: string;
    contactPhone: string;
  };
}

export async function fetchPrinceGeorgeContent(): Promise<PrinceGeorgePageContent> {
  const content: PrinceGeorgePageContent = await sanityClient.fetch(
    `*[_type == "princeGeorgePage"][0]{
      headerTitle,
      locations[]{
        locationName,
        address,
        events[]{
          date,
          time
        }
      },
      aboutSection{
        title,
        description,
        "image": image.asset->url
      },
      groundSection{
        title,
        description,
        "image": image.asset->url
      },
      findUsSection{
        title,
        description
      },
      hiringSection{
        title,
        description,
        contactEmail,
        contactPhone
      }
    }`,
  );
  return content;
}
